<!-- Invoice receipt popup -->
<p-dialog
    [(visible)]="invoiceReceiptOpen"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closable]="true"
    [showHeader]="false"
    [style]="{ width: '420px', maxWidth: '92vw' }"
    styleClass="invoice-receipt-dialog"
>
    <div class="invoice-receipt" *ngIf="selectedInvoice as invoice">
        <button type="button" class="invoice-receipt-close" (click)="invoiceReceiptOpen = false" aria-label="Close">
            <i class="pi pi-times"></i>
        </button>
        <div class="invoice-receipt-header">
            <div class="invoice-receipt-icon"><i class="pi pi-file"></i></div>
            <div class="invoice-receipt-heading">
                <div class="invoice-receipt-title">{{ invoice.isPaid ? 'Invoice paid' : 'Invoice unpaid' }}</div>
                <div class="invoice-receipt-amount">{{ (invoice.charge ?? 0) | currency | currencySpacing }}</div>
            </div>
            <span class="category-inline" *ngIf="invoice.category">{{ invoice.category }}</span>
        </div>
        <div class="invoice-receipt-items">
            <div class="invoice-receipt-line" *ngFor="let item of invoice.lineItems">
                <span class="invoice-receipt-line-name" [title]="item.name">{{ item.name }}</span>
                <span class="invoice-receipt-line-qty">×{{ item.qty }}</span>
                <span class="invoice-receipt-line-price">{{ item.price | currency | currencySpacing }}</span>
            </div>
            <div class="invoice-receipt-line invoice-receipt-line-tax" *ngIf="invoice.taxAmount > 0">
                <span class="invoice-receipt-line-name">Tax</span>
                <span class="invoice-receipt-line-price">{{ invoice.taxAmount | currency | currencySpacing }}</span>
            </div>
        </div>
        <div class="invoice-receipt-meta">
            <div class="invoice-receipt-meta-row">
                <span>Invoice number</span>
                <span>{{ invoice.invoiceNumber }}</span>
            </div>
            <div class="invoice-receipt-meta-row">
                <span>Payment date</span>
                <span>{{ invoice.date | date : "MMM d, yyyy" }}</span>
            </div>
            <div class="invoice-receipt-meta-row" *ngIf="!invoice.isOneTime && isValidNextPayment(invoice.nextPayment)">
                <span>Next payment</span>
                <span>{{ invoice.nextPayment | date : "MMM d, yyyy" }}</span>
            </div>
        </div>
        <a
            *ngIf="getStripeReceiptUrl(invoice) as stripeUrl"
            class="invoice-receipt-stripe-link"
            [href]="stripeUrl"
            target="_blank"
            rel="noopener"
        >
            View receipt <i class="pi pi-external-link"></i>
        </a>
    </div>
</p-dialog>

<!-- Upgrade / Downgrade / Cancel / Deactivate confirmation -->
<p-dialog
    [(visible)]="confirmModalOpen"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closable]="false"
    [showHeader]="false"
    [style]="{ width: '470px', maxWidth: '92vw' }"
    styleClass="plan-confirm-dialog"
>
    <div class="plan-confirm-body">
        <div class="plan-confirm-icon" [class.destructive]="confirmIsDestructive">
            <i [class]="confirmIcon"></i>
        </div>
        <div class="plan-confirm-title">{{ confirmTitle }}</div>
        <div class="plan-confirm-text">{{ confirmBody }}</div>
        <div class="plan-confirm-note" [class.destructive]="confirmIsDestructive">{{ confirmNote }}</div>
    </div>
    <div class="plan-confirm-actions">
        <button pButton type="button" class="p-button-outlined plan-confirm-dismiss" [label]="confirmDismiss" (click)="closeConfirm()"></button>
        <button
            pButton
            type="button"
            class="plan-confirm-cta"
            [class.destructive]="confirmIsDestructive"
            [label]="confirmCta"
            (click)="runConfirm()"
        ></button>
    </div>
</p-dialog>

<!-- Upgrade Existing Plans -->
<p-dialog
    header="Confirmation"
    [(visible)]="ShowCustomConfirmation"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
>
    <div *ngIf="upgradeSucessMessage.length == 0" class="plan-upgrade-message">
        <strong
            >You have chosen to
            {{ CurrentAction == 1 ? "upgrade" : "downgrade" }} your
            plan.</strong
        >
        <br /><br />
        <table class="p-datatable-table ng-star-inserted upgrade-plan">
            <tr class="ng-star-inserted">
                <td>
                    From: <strong>{{ resolvedPlanName }} plan</strong>
                </td>
                <td>
                    <strong>${{ currentSubscriptionCharges }}</strong>
                    {{
                        (planData?.subscriptionInterval === 12
                            ? "/ Year "
                            : "/ Month") + "(Subscription + Tax)"
                    }}
                </td>
            </tr>
            <tr class="ng-star-inserted">
                <td>
                    To:
                    <strong
                        >{{ _signup.selectedPlanDetails?.title }} plan</strong
                    >
                </td>
                <td>
                    <strong>${{ newSubscriptionCharges }}</strong>
                    {{
                        (planData?.subscriptionInterval === 12
                            ? "/ Year"
                            : "/ Month") + "(Subscription + Tax)"
                    }}
                </td>
            </tr>
        </table>
        <ng-container *ngIf="subscriptionChangeNotes.length > 0">
            <p-messages severity="info">
                <ng-template pTemplate>
                    <div class="ml-2">{{ subscriptionChangeNotes }}</div>
                </ng-template>
            </p-messages>
        </ng-container>
        Would you like to proceed?
    </div>
    <div *ngIf="upgradeSucessMessage.length > 0" class="plan-upgrade-message">
        <p>You have sucessfully updated your plan</p>
    </div>

    <div class="flex flex-wrap align-items-center justify-content-center m-2">
        <div class="flex align-items-center justify-content-center m-2">
            <button
                pButton
                type="button"
                label="Confirm"
                *ngIf="upgradeSucessMessage.length == 0"
                class="ml-2"
                style="width: 160px"
                (click)="performAction()"
            ></button>
            <button
                pButton
                type="button"
                label="Ok"
                class="ml-2"
                style="width: 160px"
                (click)="ShowCustomConfirmation = false"
                *ngIf="upgradeSucessMessage.length > 0"
            ></button>
            <button
                pButton
                type="button"
                label="Cancel"
                *ngIf="upgradeSucessMessage.length == 0"
                class="ml-2"
                style="width: 160px"
                (click)="ShowCustomConfirmation = false"
            ></button>
        </div>
    </div>

    <div style="color: red" *ngIf="ErrorMessage.length > 0">
        <br />
        <br />
        {{ ErrorMessage }}
    </div>
</p-dialog>

<!-- Contact Support / Change Plan Request -->
<p-dialog
    header="Contact Support"
    [(visible)]="supportDialogVisible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '760px' }"
    [breakpoints]="{ '960px': '90vw', '640px': '95vw' }"
>
    <div class="support-dialog-body">
        <div class="support-row">
            <label>Request Type</label>
            <div class="support-type-toggle">
                <button
                    type="button"
                    *ngFor="let option of supportTypeOptions"
                    class="support-type-pill"
                    [class.active]="selectedSupportType === option.value"
                    (click)="selectedSupportType = option.value"
                >
                    {{ option.label }}
                </button>
            </div>
        </div>

        <div class="support-row" *ngIf="selectedSupportType === 'change-plan'">
            <div class="support-row-head">
                <label>Select a plan</label>
                <button class="link-like" type="button" (click)="goToPricing()">
                    Need full pricing details?
                </button>
            </div>
            <div class="support-plan-list">
                <div
                    class="support-plan-card"
                    *ngFor="let plan of supportPlans"
                    [class.selected]="supportSelectedPlanId === plan.planId"
                    (click)="selectSupportPlan(plan)"
                >
                    <div class="plan-top">
                        <div class="plan-badge" *ngIf="plan.popularPlan">
                            Popular Plan
                        </div>
                        <div class="plan-radio">
                            <input
                                type="radio"
                                [id]="'support-plan-' + plan.planId"
                                name="support-plan"
                                [checked]="
                                    supportSelectedPlanId === plan.planId
                                "
                                (change)="selectSupportPlan(plan)"
                                (click)="$event.stopPropagation()"
                            />
                            <label [for]="'support-plan-' + plan.planId"
                                >Select</label
                            >
                        </div>
                    </div>

                    <div class="support-plan-card-header">
                        <div class="plan-title">{{ plan.title }}</div>
                        <div class="plan-price-badges">
                            <span class="price-chip monthly">{{
                                getSupportPlanPriceByPeriod(plan, "Monthly")
                            }}</span>
                            <span class="price-chip yearly">{{
                                getSupportPlanPriceByPeriod(plan, "Yearly")
                            }}</span>
                        </div>
                    </div>

                    <div class="plan-meta">
                        <span class="plan-description">{{
                            plan.shortDescription || plan.description
                        }}</span>
                        <div class="plan-tags">
                            <span
                                class="tag-pill"
                                *ngFor="
                                    let pkg of getIncludedPlanPackages(plan, 3)
                                "
                            >
                                {{ pkg.title }}
                            </span>
                            <span
                                class="tag-pill more-pill"
                                *ngIf="
                                    getIncludedPlanPackagesExtraCount(plan, 3) >
                                    0
                                "
                                (click)="
                                    togglePlanTags(plan);
                                    $event.stopPropagation()
                                "
                                role="button"
                                tabindex="0"
                            >
                                +{{
                                    getIncludedPlanPackagesExtraCount(plan, 3)
                                }}
                                more
                                <i class="pi pi-chevron-down"></i>
                            </span>
                            <span
                                class="tag-pill less-pill"
                                *ngIf="isPlanTagsExpanded(plan)"
                                (click)="
                                    togglePlanTags(plan);
                                    $event.stopPropagation()
                                "
                                role="button"
                                tabindex="0"
                            >
                                Show less
                                <i class="pi pi-chevron-up"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="support-row"
            *ngIf="selectedSupportType === 'change-plan'"
        >
            <label>Billing interval</label>
            <div class="support-interval-toggle" [class.disabled]="!supportSelectedPlanId">
                <button
                    type="button"
                    class="support-type-pill"
                    [disabled]="!supportSelectedPlanId || !isIntervalAvailable(selectedSupportPlan, 'Monthly')"
                    [class.active]="supportSelectedInterval === 'Monthly'"
                    (click)="selectSupportInterval('Monthly')"
                >
                    Monthly
                    <span class="interval-price" *ngIf="supportSelectedPlanId">
                        {{ getSupportPlanPriceByPeriod(selectedSupportPlan, 'Monthly') }}
                    </span>
                </button>
                <button
                    type="button"
                    class="support-type-pill"
                    [disabled]="!supportSelectedPlanId || !isIntervalAvailable(selectedSupportPlan, 'Yearly')"
                    [class.active]="supportSelectedInterval === 'Yearly'"
                    (click)="selectSupportInterval('Yearly')"
                >
                    Yearly
                    <span class="interval-price" *ngIf="supportSelectedPlanId">
                        {{ getSupportPlanPriceByPeriod(selectedSupportPlan, 'Yearly') }}
                    </span>
                </button>
            </div>
            <small class="interval-hint" *ngIf="!supportSelectedPlanId">
                Select a plan to choose the billing interval.
            </small>
            <small
                class="interval-hint warning"
                *ngIf="supportSelectedPlanId && !hasAnyInterval(selectedSupportPlan)"
            >
                This plan does not list billing intervals. Please contact support.
            </small>
        </div>

        <div class="support-row">
            <label>Details</label>
            <textarea
                rows="4"
                [(ngModel)]="supportMessage"
                placeholder="Describe what you need help with..."
            ></textarea>
        </div>

        <div class="support-error" *ngIf="supportRequestError">
            {{ supportRequestError }}
        </div>
    </div>

    <ng-template pTemplate="footer">
        <button
            pButton
            type="button"
            label="Cancel"
            class="p-button-text"
            (click)="closeSupportDialog()"
        ></button>
        <button
            pButton
            type="button"
            label="Save"
            [disabled]="supportRequestSending || isSupportSaveDisabled()"
            (click)="saveSupportRequest()"
        ></button>
    </ng-template>
</p-dialog>
<!-- /Upgrade Existing Plans  -->

<div class="billing-container">
    <div class="billing-header">
        <div class="billing-header-text">
            <h1>Subscription Management</h1>
        </div>
        <div class="billing-actions-top">
            <button
                class="contact-store-btn"
                type="button"
                [disabled]="supportRequestSending"
                (click)="openSupportDialog()"
            >
                {{
                    supportRequestSending
                        ? "Sending..."
                        : "Need help with plans or billing?"
                }}
            </button>
        </div>
    </div>
    <div class="billing-grid billing-grid-stacked">
        <div class="billing-summary">
            <ng-container *ngIf="!isSummaryLoading; else summarySkeleton">
            <div class="billing-hero">
                <div class="hero-main">
                    <div class="hero-top-row">
                        <span class="hero-eyebrow">CURRENT PLAN</span>
                        <span class="hero-status-pill"><span class="hero-status-dot"></span>{{ planStatusText }}</span>
                    </div>
                    <div class="hero-plan-name">{{ resolvedPlanName }}<span class="hero-plan-amount" *ngIf="!isFreePlan">{{ rawPlanCost | currency | currencySpacing }}/{{ billingCycleLabel === "Yearly" ? "yr" : "mo" }}</span></div>
                    <div class="hero-price-row">
                        <span class="hero-price">{{ isFreePlan ? "$0.00" : (nextPaymentAmount | currency | currencySpacing) }}</span>
                        <span class="hero-price-per">/{{ billingCycleLabel === "Yearly" ? "year" : "month" }}</span>
                    </div>
                    <div class="hero-stat-subvalue" *ngIf="!isFreePlan">
                        {{ planPriceAmount | currency | currencySpacing }} + {{ nextPaymentTaxAmount | currency | currencySpacing }} tax
                    </div>
                    <div class="hero-chips" *ngIf="planChips.length">
                        <span class="hero-chip" *ngFor="let chip of planChips">{{ chip }}</span>
                    </div>
                    <div class="hero-stat-subvalue" *ngIf="lastPlanChange">
                        Changed from {{ lastPlanChange.fromTitle }} to {{ lastPlanChange.toTitle }} on {{ lastPlanChange.date | date : "MMM d, yyyy" }}
                    </div>
                </div>

                <div class="hero-stats">
                    <div class="hero-stat">
                        <div class="hero-stat-label">BILLING CYCLE</div>
                        <div class="hero-stat-value">{{ billingCycleLabel }}</div>
                    </div>
                    <div class="hero-stat">
                        <div class="hero-stat-label">SUBSCRIBED ON</div>
                        <div class="hero-stat-value">{{ subscribedOnDate ? (subscribedOnDate | date : "MMM d, yyyy") : "—" }}</div>
                    </div>
                    <div class="hero-stat">
                        <div class="hero-stat-label">NEXT BILLING DATE</div>
                        <div class="hero-stat-value">{{ nextBillingDate ? (nextBillingDate | date : "MMM d, yyyy") : "No renewal" }}</div>
                    </div>
                    <div class="hero-stat">
                        <div class="hero-stat-label">TOTAL DUE NEXT (INCL. TAX)</div>
                        <div class="hero-stat-value">{{ isFreePlan ? "$0.00" : (nextPaymentAmount | currency | currencySpacing) }}</div>
                    </div>
                </div>

                <!-- TODO re-enable: flip this back on to restore the plan action buttons -->
                <div class="hero-actions" *ngIf="false">
                    <button pButton type="button" label="Upgrade plan" class="hero-btn hero-btn-primary" [disabled]="!canUpgrade" (click)="doUpgrade()"></button>
                    <button pButton type="button" label="Downgrade plan" class="hero-btn hero-btn-outline" [disabled]="!canDowngrade" (click)="doDowngrade()"></button>
                    <a class="hero-link" *ngIf="canCancelSubscription" (click)="requestCancelSubscription()">{{ isCancellingSubscription ? "Cancelling…" : "Cancel subscription" }}</a>
                    <a class="hero-link" *ngIf="canDeactivateAccount" (click)="requestDeactivateAccount()">Deactivate account</a>
                </div>
            </div>
            </ng-container>
            <ng-template #summarySkeleton>
                <div class="billing-hero">
                    <p-skeleton width="40%" height="1.5rem" styleClass="mb-3"></p-skeleton>
                    <p-skeleton width="70%" height="1rem" styleClass="mb-2"></p-skeleton>
                    <p-skeleton width="90%" height="1rem" styleClass="mb-2"></p-skeleton>
                    <p-skeleton width="100%" height="2.5rem" styleClass="mb-2"></p-skeleton>
                    <p-skeleton width="80%" height="2.5rem"></p-skeleton>
                </div>
            </ng-template>

            <ng-container *ngIf="!isSummaryLoading; else usageSkeleton">
            <div class="billing-usage-grid" [class.three-col]="hardwareSectionVisible || purchasedHardwareList.length">
                <div class="usage-card">
                    <div class="usage-card-header">
                        <div>
                            <h3>Locations &amp; registers</h3>
                            <p>Every plan includes {{ includedLocationCount }} location and {{ includedRegisterCount }} register. Add more whenever you grow.</p>
                        </div>
                        <button pButton type="button" icon="pi pi-plus" label="Buy more" class="usage-card-cta" *ngIf="canBuyMoreUsage" (click)="buyMoreRegistersAndLocations()"></button>
                    </div>
                    <div class="usage-row">
                        <div class="usage-row-icon"><i class="pi pi-map-marker"></i></div>
                        <div class="usage-row-main">
                            <div class="usage-row-title">Locations</div>
                            <div class="usage-row-sub">{{ includedLocationCount }} included &middot; {{ locationExtraPrice | currency | currencySpacing }}/mo each extra</div>
                        </div>
                        <div class="usage-row-end">
                            <div class="usage-row-count">{{ locationCount }}</div>
                            <div class="usage-row-extra">{{ extraLocationCount > 0 ? (extraLocationCount + ' extra') : 'No extras' }}</div>
                        </div>
                    </div>
                    <div class="usage-row">
                        <div class="usage-row-icon"><i class="pi pi-desktop"></i></div>
                        <div class="usage-row-main">
                            <div class="usage-row-title">Registers</div>
                            <div class="usage-row-sub">{{ includedRegisterCount }} included &middot; {{ registerExtraPrice | currency | currencySpacing }}/mo each extra</div>
                        </div>
                        <div class="usage-row-end">
                            <div class="usage-row-count">{{ registerCount }}</div>
                            <div class="usage-row-extra">{{ extraRegisterCount > 0 ? (extraRegisterCount + ' extra') : 'No extras' }}</div>
                        </div>
                    </div>
                </div>

                <div class="usage-card">
                    <div class="usage-card-header">
                        <div>
                            <h3>Add-ons</h3>
                            <p>Optional features billed alongside your subscription.</p>
                        </div>
                        <span class="usage-addon-count-badge">{{ activeAddonCount }} of {{ subscriptionAddonsList.length }} active</span>
                    </div>
                    <div class="usage-addon-row" *ngFor="let addon of subscriptionAddonsList; trackBy: trackAddonById">
                        <div class="usage-row-icon usage-addon-icon"><i class="pi pi-star-fill"></i></div>
                        <div class="usage-row-main">
                            <div class="usage-row-title">
                                {{ addon.planName }}
                            </div>
                            <div class="usage-row-sub">{{ getAddonPrice(addon) | currency | currencySpacing }}<ng-container *ngIf="addon.priceIsStartingAt">+</ng-container>/mo</div>
                        </div>
                        <div class="usage-row-end">
                            <span class="usage-addon-included-badge" *ngIf="addon.included">Included</span>
                            <ng-container *ngIf="!addon.included">
                                <span class="usage-addon-price">{{ getAddonPrice(addon) | currency | currencySpacing }}<ng-container *ngIf="addon.priceIsStartingAt">+</ng-container>/mo</span>
                                <button pButton type="button" label="Add" class="usage-addon-add-btn" (click)="addSubscriptionAddon(addon)"></button>
                            </ng-container>
                        </div>
                    </div>
                    <p class="usage-addon-empty" *ngIf="!subscriptionAddonsList.length">No add-ons are available for your current plan.</p>
                </div>

                <div class="usage-card" *ngIf="hardwareSectionVisible || purchasedHardwareList.length">
                    <div class="usage-card-header">
                        <div>
                            <h3>Hardware</h3>
                            <p>POS terminals, card readers and accessories for in-store selling.</p>
                        </div>
                        <button pButton type="button" icon="pi pi-shopping-cart" label="Buy hardware" class="usage-card-cta" *ngIf="hardwareSectionVisible" (click)="goToHardwareShop()"></button>
                    </div>
                    <div class="usage-card-scroll" *ngIf="purchasedHardwareList.length">
                        <div class="usage-row" *ngFor="let hw of purchasedHardwareList; trackBy: trackHardwareByName">
                            <div class="usage-row-icon"><i class="pi pi-box"></i></div>
                            <div class="usage-row-main">
                                <div class="usage-row-title">{{ hw.name }}</div>
                                <div class="usage-row-sub">{{ hw.price | currency | currencySpacing }}</div>
                            </div>
                            <div class="usage-row-end">
                                <div class="usage-row-count">{{ hw.qty }}</div>
                                <div class="usage-row-extra">Qty</div>
                            </div>
                        </div>
                    </div>
                    <p class="usage-addon-empty" *ngIf="!purchasedHardwareList.length">No hardware purchased yet.</p>
                </div>
            </div>

            <div class="usage-card payment-method-card" *ngIf="!isFreePlan">
                <div class="usage-card-header">
                    <div>
                        <h3>Payment method</h3>
                        <p>Charged for your subscription, add-ons and hardware orders.</p>
                    </div>
                </div>
                <app-stripe-payment-methods [showHeader]="false"></app-stripe-payment-methods>
            </div>
            </ng-container>
            <ng-template #usageSkeleton>
                <div class="billing-usage-grid">
                    <div class="usage-card">
                        <p-skeleton width="50%" height="1.25rem" styleClass="mb-3"></p-skeleton>
                        <p-skeleton width="100%" height="3.5rem" styleClass="mb-2"></p-skeleton>
                        <p-skeleton width="100%" height="3.5rem"></p-skeleton>
                    </div>
                    <div class="usage-card">
                        <p-skeleton width="40%" height="1.25rem" styleClass="mb-3"></p-skeleton>
                        <p-skeleton width="100%" height="3.5rem" styleClass="mb-2"></p-skeleton>
                        <p-skeleton width="100%" height="3.5rem"></p-skeleton>
                    </div>
                </div>
            </ng-template>

    <!-- Second Part -->

    <!-- <div class="plans-container"> -->
    <!-- Title intentionally removed per request -->
    <!-- <div class="billing-options">
    <span class="billing-options-btns" *ngIf="currentPlanDetails?.isFreeTrial">
      <button [ngClass]="{'active': !isMonthly}" (click)="currentInterval(false)" >Annually (saves up to 20%)</button>
      <button [ngClass]="{'active': isMonthly}" (click)="currentInterval(true)" >Monthly</button>
    </span>
  </div>
  <div class="plans">
    <div class="plan-card recommended" *ngFor="let plan of plans;let index = i">
      <div class="plan-header">
         <h2>{{plan.title}}</h2>
      </div>
      <div class="plan-price">
        <span>{{plan?.prices?.value | currency | currencySpacing }}</span>/month
      </div>
      <div class="plan-billing">
        {{(plan?.prices?.priceLimitTypeString === 'BilledAnnually' ? 'billed annually (USD)' : 'billed monthly (USD)')}}
      </div>
      <button *ngIf="!plan?.selected" (click)="goToCheckOut(plan)" >{{plan.button}}</button>
      <button *ngIf="plan?.selected" class="active-plan-btn" >{{plan.button }}</button>
      <div class="plan-features cursor-pointer" (click)="goToPricing()">
        See all features <img class="px-2" src="assets/images/see_all_features.svg">
      </div>
    </div>
  </div> -->
    <!-- </div> -->
        </div>

    <div class="billing-history-container">
        <h2>Billing History</h2>
        <ng-container *ngIf="!isHistoryLoading; else historySkeleton">
        <div class="billing-history-table billing-history-table-simple">
            <div class="table-header">
                <div>Date</div>
                <div>Total</div>
                <div>Status</div>
                <div>Actions</div>
            </div>
            <div class="table-body">
                <div
                    *ngFor="let invoice of getDisplayInvoices()"
                    class="table-row"
                >
                    <div data-label="Date">{{ invoice.date | date : "MMM d, yyyy" }}</div>
                    <div data-label="Total">{{ (invoice.charge ?? 0) | currency | currencySpacing }}</div>
                    <div data-label="Status">
                        <span class="invoice-status-paid" *ngIf="invoice.isPaid">Paid</span>
                        <span class="invoice-status-unpaid" *ngIf="!invoice.isPaid">Unpaid</span>
                    </div>
                    <div data-label="Actions">
                        <a class="invoice-view-link" (click)="openInvoiceReceipt(invoice)">View</a>
                        <a
                            *ngIf="getStripeReceiptUrl(invoice) as stripeUrl"
                            class="invoice-view-link"
                            [href]="stripeUrl"
                            target="_blank"
                            rel="noopener"
                        >Receipt</a>
                    </div>
                </div>
            </div>
        </div>
        </ng-container>
        <ng-template #historySkeleton>
            <div class="billing-history-table billing-history-table-simple">
                <div class="table-header">
                    <div><p-skeleton width="60%" height="1rem"></p-skeleton></div>
                    <div><p-skeleton width="50%" height="1rem"></p-skeleton></div>
                    <div><p-skeleton width="50%" height="1rem"></p-skeleton></div>
                    <div><p-skeleton width="40%" height="1rem"></p-skeleton></div>
                </div>
                <div class="table-body">
                    <div class="table-row" *ngFor="let row of [1,2]">
                        <div><p-skeleton width="70%" height="1rem"></p-skeleton></div>
                        <div><p-skeleton width="50%" height="1rem"></p-skeleton></div>
                        <div><p-skeleton width="50%" height="1rem"></p-skeleton></div>
                        <div><p-skeleton width="40%" height="1rem"></p-skeleton></div>
                    </div>
                </div>
            </div>
        </ng-template>
    </div>
    </div>
</div>




